import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import AuthShell from "@/components/AuthShell";
import PasswordInput from "@/components/PasswordInput";

const PW_OK = (p) => p.length >= 11 && /[A-Z]/.test(p) && /[a-z]/.test(p) && /\d/.test(p) && /[^A-Za-z0-9]/.test(p);

const inputCls = "w-full bg-surface-2 border border-border rounded-md px-4 py-3 text-fg text-sm focus:outline-none focus:ring-2 focus:ring-accent/60 focus:border-accent/40 transition-shadow";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!PW_OK(password)) { toast.error("Mot de passe : 11 caractères min., majuscule, minuscule, chiffre et caractère spécial."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Nouveau mot de passe" subtitle="Choisissez un nouveau mot de passe."
      footer={<Link to="/login" className="text-accent hover:underline">Retour à la connexion</Link>}>
      {!token ? (
        <div className="surface rounded-md p-6 text-sm text-muted">Lien invalide ou expiré.</div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div>
            <label className="overline block mb-2">Nouveau mot de passe</label>
            <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} required minLength={11} placeholder="11 caractères minimum" testid="reset-password" />
            <p className="text-xs text-muted mt-2">11 caractères min., avec majuscule, minuscule, chiffre et caractère spécial.</p>
          </div>
          <button type="submit" disabled={loading} data-testid="reset-submit"
            className="w-full bg-accent text-black font-semibold py-3 rounded-md hover-lift disabled:opacity-60">
            {loading ? "Enregistrement…" : "Réinitialiser"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
